import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function WTPConsumerAcceptance() {
  return (
    <div className="art-page">
      <SEO
        title="Willingness to Pay and Consumer Acceptance Assessment for Clean Cooking in Uganda — World Bank"
        description="In 2015, CIRCODU implemented Uganda's most comprehensive consumer acceptance study of improved cookstoves to date, commissioned by Rebel Group International on behalf of the World Bank."
        keywords="willingness to pay, consumer acceptance, clean cooking, Uganda, improved cookstoves, Rebel Group International, World Bank, consumer research, stove usage patterns, price sensitivity, market survey, Kitchen Performance Tests, CIRCODU, willingness to pay study Uganda, consumer acceptance study Uganda, clean cooking Uganda, improved cookstoves Uganda, Rebel Group International Uganda, World Bank Uganda"
        url="/Willingness-to-Pay-and-Consumer-Acceptance-Assessment-for-Clean-Cooking-in-Uganda-World-Bank"
        datePublished="2015-08-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Willingness to Pay and Consumer Acceptance Assessment — World Bank
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              August 01, 2015
            </div>
            <h1 className="art-title">
              Willingness to Pay and Consumer Acceptance Assessment for Clean
              Cooking in Uganda — World Bank
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                In 2015, CIRCODU implemented Uganda's most comprehensive
                consumer acceptance study of improved cookstoves to date,
                commissioned by <strong>Rebel Group International</strong> on
                behalf of the <strong>World Bank</strong>. The study was
                designed to address a critical gap in clean cooking market
                development: understanding not just whether consumers would buy
                improved stoves, but{" "}
                <em>
                  at what price, under what conditions, and with what
                  expectations
                </em>
                .
              </p>
              <p>
                Seven stove models were tested — five charcoal-burning and two
                wood-burning — spanning the range of technologies being
                considered for large-scale dissemination across Uganda's urban
                and peri-urban markets.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                CIRCODU managed the full research lifecycle from baseline to
                exit:
              </p>
              <ol>
                <li>
                  <strong>Baseline phase:</strong> Participant recruitment,
                  Kitchen Performance Tests, and a demographic and social impact
                  survey to characterise the study population and document
                  pre-intervention cooking practices.
                </li>
                <li>
                  <strong>Stove dissemination:</strong> CIRCODU oversaw
                  distribution to study households, conducting training and
                  installation sessions and deploying{" "}
                  <strong>Stove Usage Monitors (i-buttons)</strong> to
                  objectively track stove use over time.
                </li>
                <li>
                  <strong>Midterm assessment:</strong> Evaluation of evolved
                  usage patterns, market survey of the wider cookstove retail
                  landscape, and willingness-to-pay experiments to establish the
                  price ceiling beyond which consumers would not purchase each
                  model.
                </li>
                <li>
                  <strong>Exit study:</strong> Follow-up KPTs measuring changes
                  in fuel consumption and consumer perceptions of stove
                  performance, durability, and satisfaction.
                </li>
              </ol>
              <h2 className="art-subheading">Significance</h2>
              <p>
                The study's findings directly informed the design of the{" "}
                <strong>
                  Uganda Clean Cooking Supply Chain Expansion Project
                </strong>
                , providing the demand-side data the World Bank used to select
                stove technologies, set subsidy levels, and structure consumer
                engagement strategies. It remains one of the most
                methodologically thorough consumer assessments of cookstoves
                conducted in sub-Saharan Africa.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's consumer research services,
                contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
